import React, { useEffect, useState } from 'react';
import {
	addToWatchlist,
	getAllAssetPowerusers,
	removeFromWatchlist,
} from '../../../api/watchlist';
import { Button } from '../../../components/Button';
import useAsync from '../../../hooks/useAsync';
import DataTable from '../../../components/DataTable';
import { getTeam } from '../../../api/company';
import Modal from '../../../components/Shell/Modal';
import {
	AttributeRow,
	TemplateReactSelect,
} from '../../../components/Attributes/Attributes_old';
import { getUserFullName } from '../../../components/helpers/functions';
import { getAllPowerUsers } from '../../../api/power-users';
import { PlusCircleIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import useModal from '../../../hooks/useModal';
import usePrevious from '../../../hooks/usePrevious';

export default ({ item, refresh }) => {
	const [emailToAdd, setEmailToAdd] = useState({});
	const [addWatcherModalOpen, setAddWatcherModalOpen] = useState(false);
	const { setOpen: onOpenAddPowerUser } = useModal('addPowerUser');

	const { execute: onAddToWatchlist, status: addingToWatchlist } = useAsync(
		addToWatchlist,
		{ immediate: false },
	);

	const { value: teammembers, execute: onRefreshUsers } = useAsync(getTeam, {
		immediate: false,
	});

	const { value: allAssetPowerUsers, execute: onRefreshAvailablePowerusers } =
		useAsync(getAllAssetPowerusers, { immediate: false });

	const { value: availablePowerusers } = useAsync(getAllPowerUsers);

	const { execute: onRemoveFromWatchlist, status: removingFromWatchlist } =
		useAsync(removeFromWatchlist, { immediate: false });

	const prevWatcherModal = usePrevious(addWatcherModalOpen);
	useEffect(() => {
		if (!prevWatcherModal || (prevWatcherModal && !addWatcherModalOpen)) {
			onRefreshAvailablePowerusers({ assetId: item?.id });
			onRefreshUsers();
		}
	}, [addWatcherModalOpen]);

	return (
		<>
			<div className="block sm:hidden">
				{/*<h2 className="flex sm:items-baseline flex-col sm:flex-row text-base/7 font-semibold text-zinc-950 sm:text-sm/6 mr-4">
											Documents
										</h2>
						
										<div className="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
											<dd className="mt-2 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
												<ul
													role="list"
													className="divide-y divide-gray-100 rounded-md border border-gray-200"
												>
													<li className="flex items-center justify-between py-4 pr-5 pl-4 text-sm/6">
														<div className="flex w-0 flex-1 items-center">
															<PaperClipIcon
																aria-hidden="true"
																className="size-5 shrink-0 text-gray-400"
															/>
															<div className="ml-4 flex min-w-0 flex-1 gap-2">
																<div>
																	<div className="truncate font-medium text-gray-900">
																		resume_back_end_developer.pdf
																	</div>
																	<div className="shrink-0 text-gray-400">2.4mb</div>
																</div>
															</div>
														</div>
													</li>
												</ul>
											</dd>
										</div>*/}
			</div>
			<div className="hidden sm:block grid grid-cols-12 py-4">
				<div className="flex items-center justify-between">
					<div className=" text-lg font-semibold">
						<span className="block sm:hidden">Power Users</span>
					</div>
					<div className="flex items-center">
						{/*<Button type="secondary">Add Existing Document</Button>*/}
						<Button
							Icon={UserGroupIcon}
							onClick={() => {
								setAddWatcherModalOpen(true);
							}}
						>
							Add Power User
						</Button>
					</div>
				</div>

				<div className="mt-6">
					<DataTable
						data={{ rows: allAssetPowerUsers || [] }}
						columns={[
							{
								header: 'Email',
								accessorKey: 'email',
								cell: (info) => {
									const row = info?.row?.original;
									return row?.user?.email || row?.poweruser?.email || '';
								},
							},
							{
								header: 'First name',
								accessorKey: 'firstName',
								cell: (info) => {
									const row = info?.row?.original;
									return (
										row?.user?.firstName || row?.poweruser?.firstName || ''
									);
								},
							},
							{
								header: 'Last name',
								accessorKey: 'lastName',
								cell: (info) => {
									const row = info?.row?.original;
									return row?.user?.lastName || row?.poweruser?.lastName || '';
								},
							},
							{
								header: 'Has account',
								accessorKey: 'userId',
								cell: (info) => {
									return info?.getValue() ? 'Yes' : 'No';
								},
							},
						]}
						hasCheckboxes={false}
						useExport={false}
						usePagination={false}
						useSearch={false}
						disableTitle
						rowActions={[
							{
								name: 'Remove',
								onClick: (row) => {
									onRemoveFromWatchlist(row?.original?.id, () =>
										refresh({ id: item?.id }, null, { silent: true }),
									);
								},
							},
						]}
					/>
				</div>
			</div>

			<Modal
				open={addWatcherModalOpen}
				onClose={() => setAddWatcherModalOpen(false)}
			>
				<AttributeRow name="Available to Add" span="sm:col-span-1">
					<div className="flex items-center">
						<div className="w-full">
							<TemplateReactSelect
								formatOptionLabel={({ label, type }) => (
									<div className="flex justify-between items-center cursor-pointer">
										<div>{label}</div>
										<div className="text-gray-400 text-xxs pl-3 truncate">
											{type === 'user' ? 'User' : 'Power User'}
										</div>
									</div>
								)}
								options={[
									{
										label: 'Active Users',
										options: teammembers?.rows?.length
											? teammembers?.rows?.map((member) => ({
													label: getUserFullName(member),
													value: member?.id,
													type: 'user',
												}))
											: [],
									},
									{
										label: 'Power Users',
										options: availablePowerusers?.length
											? availablePowerusers?.map((member) => ({
													label: getUserFullName(member),
													value: member?.id,
													type: 'powermember',
												}))
											: [],
									},
								]}
								onChange={(index, user, raw) => {
									onAddToWatchlist(
										{
											asset_id: item?.id,
											...(user?.type === 'powermember'
												? { power_user_id: user?.value }
												: { user_id: user?.value }),
										},
										() => {
											setAddWatcherModalOpen(false);
											onRefreshUsers();
										},
									);
								}}
							/>
						</div>
						<div className="flex-shrink flex items-center -mt-3 pt-3 ml-3">
							<PlusCircleIcon
								className="w-6 h-6 cursor-pointer text-gray-500"
								onClick={({ user }) =>
									onOpenAddPowerUser({
										assetId: item?.id,
										onSubmit: (response) => {
											setAddWatcherModalOpen(false);
											onRefreshUsers();
										},
									})
								}
							/>
						</div>
					</div>
				</AttributeRow>

				<div className="flex justify-end mt-3">
					<Button onClick={() => {}} disabled={true}>
						Add
					</Button>
				</div>
			</Modal>
		</>
	);

	return (
		<>
			<div className="py-6">
				<div className="flex justify-end">
					<Button onClick={() => setAddWatcherModalOpen(true)}>Add</Button>
				</div>

				{item?.watchlists?.length ? (
					<table className="min-w-full divide-y divide-gray-300">
						<thead>
							<tr>
								<th
									scope="col"
									className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900"
								>
									User
								</th>
								<th
									scope="col"
									className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900"
								>
									Role
								</th>
								<th
									scope="col"
									className="relative py-3.5 pl-3 pr-4 sm:pr-3"
								></th>
							</tr>
						</thead>
						<tbody className="bg-white">
							{item?.watchlists?.map((person, personIdx) => (
								<tr
									key={person.email}
									className={personIdx % 2 === 0 ? undefined : 'bg-gray-50'}
								>
									<td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-3">
										{person?.user
											? `${person?.user?.firstName} ${person?.user?.lastName}`
											: `${
													person?.firstName || person?.lastName
														? `${person?.firstName || ''} ${
																person?.lastName || ''
															} (${person?.email})`
														: person.email
												}`}
									</td>
									<td className="whitespace-nowrap px-3 py-4 text-xs text-gray-500">
										{person.user ? 'User' : 'Email Only'}
									</td>
									<td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3">
										<Button
											type="ghost"
											onClick={() => {
												onRemoveFromWatchlist(person?.id, () =>
													refresh({ id: item?.id }, null, { silent: true }),
												);
											}}
											disabled={removingFromWatchlist === 'pending'}
										>
											{removingFromWatchlist === 'pending'
												? 'Removing...'
												: 'Remove'}
										</Button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<p className="text-center py-12 text-gray-600">
						No users added to the watchlist
					</p>
				)}
			</div>
		</>
	);
};
